import React, { useEffect, useRef, useState } from 'react';
import { DropdownOption } from './DropdownOption';
import { SubFilterDropdown } from './SubFilterDropdown';
export const SubFilter = (props) => {
    const [dropdownOpen, updateDropdown] = useState(false);
    const toggleDropdown = () => {
        updateDropdown(!dropdownOpen);
    };
    const dropdownRef = useRef(null);
    const toggleButton = useRef(null);
    useEffect(() => {
        document.addEventListener("click", function (event) {
            const target = event.target;
            const nearestDropdown = target.closest(".filter-dropdown-js");
            if (nearestDropdown === null || nearestDropdown !== dropdownRef.current) {
                updateDropdown(false);
            }
        });
    }, []);
    const keyPressed = (event) => {
        if (event.key == "Escape") {
            updateDropdown(false);
            toggleButton.current.focus();
        }
    };
    const dropdownOptions = props.data.map(x => (React.createElement(DropdownOption, { key: `${x.termId}-${x.hierarchy}`, termId: x.termId, name: x.name, hierarchy: x.hierarchy, active: x.active, handleClick: props.handleClick })));
    // are any terms selected?
    const selected = props.data.some(element => {
        return element.active;
    });
    return (React.createElement("div", { ref: dropdownRef, className: "mr-8 filter-dropdown filter-dropdown-js" },
        React.createElement("button", { className: "filter-dropdown__header w-max cursor-pointer", onClick: () => toggleDropdown(), "aria-label": `Submenu of ${props.label}`, ref: toggleButton },
            React.createElement("span", { className: "headline small2 mr-2" }, props.label),
            " ",
            React.createElement("img", { src: `/assets/images/down-arrow${props.color == "white" ? "-white" : ""}.svg`, className: "inline align-baseline", alt: `Open ${props.label} picker` })),
        React.createElement(SubFilterDropdown, { open: dropdownOpen, selected: selected, elements: dropdownOptions, hierarchy: props.hierarchy, clearDropdownHandler: props.clearDropdownHandler, onKeyDown: keyPressed })));
};
